import { fmtUSD } from "@/lib/api";
import { WireTable } from "./WireTable";
import { DirectionMix, TopClients } from "./WireCharts";

function Kpi({ id, label, value, sub, tone }) {
  const c = { danger: "border-l-red-500", warn: "border-l-amber-500", accent: "border-l-sky-500" }[tone] || "border-l-slate-700";
  return (
    <div className={`panel border-l-2 ${c} p-4 rise`}>
      <div className="eyebrow">{label}</div>
      <div key={value} data-testid={`kpi-${id}`} className="num text-3xl text-slate-900 mt-2 flash rounded">{value}</div>
      {sub && <div className="text-[11px] text-slate-500 mt-1">{sub}</div>}
    </div>
  );
}

function Rollup({ rollup, onBank }) {
  const max = Math.max(...rollup.map((r) => r.value), 1);
  return (
    <div className="panel" data-testid="bank-rollup">
      <div className="px-4 py-3 border-b border-slate-200 eyebrow">Rollup by bank</div>
      <div className="p-2 max-h-[340px] overflow-y-auto thin-scroll">
        {rollup.map((r) => (
          <button key={r.bank} data-testid={`rollup-bank-${r.bank.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => onBank(r.bank)} className="w-full text-left px-2 py-2 rounded hover:bg-slate-100 transition-colors">
            <div className="flex justify-between text-xs"><span className="text-slate-800">{r.bank}</span><span className="num text-slate-700">{fmtUSD(r.value, true)}</span></div>
            <div className="h-1.5 bg-slate-100 rounded mt-1.5 overflow-hidden"><div className="h-full bg-sky-600/80 rounded transition-[width] duration-500" style={{ width: `${(r.value / max) * 100}%` }} /></div>
            <div className="flex gap-3 text-[10px] num text-slate-500 mt-1"><span>{r.count} wires</span>{r.holds > 0 && <span className="text-red-600">{r.holds} holds</span>}{r.review > 0 && <span className="text-amber-600">{r.review} review</span>}</div>
          </button>
        ))}
        {!rollup.length && <div className="p-3 text-xs text-slate-500">No wires match.</div>}
      </div>
    </div>
  );
}

export function WireDashboard({ q, onOpenAlert, onBank }) {
  const k = q.kpis;
  return (
    <div className="p-6 space-y-5" data-testid="wire-dashboard">
      <div className="grid grid-cols-2 xl:grid-cols-4 gap-3">
        <Kpi id="count" label="Wire count" value={k.count.toLocaleString()} tone="accent" sub={`of ${k.universe} in 30-day window`} />
        <Kpi id="value" label="Total value" value={fmtUSD(k.value, true)} tone="accent" />
        <Kpi id="pending" label="Pending" value={k.pending} tone="warn" sub={`${k.needs_review} need AML review`} />
        <Kpi id="holds" label="AML holds" value={k.aml_holds} tone="danger" />
      </div>
      <div className="grid lg:grid-cols-2 2xl:grid-cols-3 gap-4 items-start">
        <TopClients q={q} />
        <DirectionMix q={q} />
        <Rollup rollup={q.rollup} onBank={onBank} />
      </div>
      <WireTable rows={q.rows} limit={15} onOpenAlert={onOpenAlert} source={q.source} />
    </div>
  );
}
